import { httpCreate } from './http';

const http = httpCreate('/srv/activity-statistics-like-config');

export const activityStatisticsLikeConfig = {
	getActivityStatisticsLikeConfig(activityId) {
		return http.get(`/${activityId}`);
	},
	switchShowType(activityId, likeShowType) {
		return http.post(`/showType/${activityId}/${likeShowType}`);
	},
	setActivityStatisticsLikeConfig(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
};
